export enum RelationValues {
  requirement_to_upload = 1,
  requirement_to_show = 2,
  requirement_to_sign = 3,
  physical_result = 4,
  dematerialized_result = 5,
  // requirement_to_print_upload = 6,
}
